var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 6.01088 14.7098 4.10322 13.3033 2.6967C11.8968 1.29018 9.98912 0.5 8 0.5ZM8.15 11.975C7.8184 11.9817 7.51574 11.787 7.38431 11.4825C7.25288 11.178 7.31883 10.8242 7.55116 10.5876C7.7835 10.3509 8.13598 10.2783 8.44288 10.4041C8.74978 10.5298 8.95004 10.8288 8.9495 11.1605C8.95201 11.6055 8.595 11.9692 8.15 11.975ZM8.789 8.4215C9.33847 8.09195 9.77316 7.60122 10.034 7.016C10.2454 6.58378 10.2908 6.08897 10.1615 5.6255C9.86309 4.60389 8.88285 3.93677 7.823 4.034C6.89771 4.09524 6.11095 4.73185 5.858 5.624C5.81717 5.80873 5.78613 5.99549 5.765 6.1835H7.046C7.04837 6.16904 7.05063 6.15503 7.05283 6.14138C7.06454 6.06869 7.07458 6.00641 7.091 5.942C7.2245 5.4455 7.766 5.1845 8.312 5.3345C8.75469 5.45494 9.02431 5.90232 8.924 6.35C8.87294 6.59414 8.76787 6.82376 8.6165 7.022C8.3296 7.39373 7.95204 7.68555 7.52 7.8695C7.45211 7.89118 7.40885 7.95764 7.4165 8.0285V9.269C7.4165 9.28869 7.41879 9.308 7.42107 9.32712C7.42329 9.34587 7.4255 9.36443 7.4255 9.383H8.681V8.6105C8.67253 8.53081 8.71604 8.45466 8.789 8.4215Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIconRed);
export default __webpack_public_path__ + "static/media/question-icon-red.d52fbcd714582118cb13f2570125de3b.svg";
export { ForwardRef as ReactComponent };